export default __webpack_public_path__ + "static/media/mode-10.d8957f07.svg";